import React from 'react';

import { Container } from '@mui/material';

import classes from './NgzChallengePreview.module.scss';
import { ChallengesHeader } from '../../components/ChallengesHeader/ChallengesHeader';
import { angularizeWithProviders } from '../../../shared/providers';
import { LbChip } from '../../../shared/components/ui-components';

import { ChallengeLandingContent } from '../../containers/ChallengeLandingContent/ChallengeLandingContent';
import { useChallengeInfo } from '../../hooks/useChallengeInfo';
import { privateChallengeInfoService } from '../../services/challenge-info/privateChallengeInfoService';
import { getRouteParam, goTo } from '../../../shared/utils/angularUtils';
import { CHALLENGE_STATUS } from '../../constants/challengeStatus';
import { ErrorState } from '../../../shared/components/ErrorState/ErrorState';

const NgzChallengePreview = () => {
  const challengeId = getRouteParam('challengeId');

  const { challengeInfo, isNotFound } = useChallengeInfo({
    challengeId,
    getChallengeInfo: privateChallengeInfoService.getChallengeInfo,
  });

  if (isNotFound) {
    return (
      <ErrorState
        title="We couldn't find this page"
        description={
          <>
            Looks like the link might be incomplete or incorrect.
            <br />
            Please double-check the address and try again — or copy the full link from the
            original message.
          </>
        }
      />
    );
  }

  if (!challengeInfo) {
    return null;
  }

  if (challengeInfo.challenge.status !== CHALLENGE_STATUS.DRAFT) {
    goTo(`/challenge-landing/${challengeId}`, { replaceHistory: true });
  }

  return (
    <>
      <ChallengesHeader />
      <Container maxWidth="md">
        <ChallengeLandingContent
          challengeInfo={challengeInfo}
          headerBlock={
            <LbChip
              className={classes.draftChip}
              size="small"
              color="info"
              label="Draft. Needs to be published"
            />
          }
        />
      </Container>
    </>
  );
};

angularizeWithProviders(NgzChallengePreview, 'ngzChallengePreview', {});
